var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSeedsBag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "none",
    width: 52.9032,
    height: 52.9032,
    transform: "translate(0.225586 0.87085)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M48.4273 8.87184V0.87085H4.92676V8.87184L6.47666 13.5215V41.1234L4.92676 45.7731V53.7741H48.4273V45.7731L46.8774 41.1234V13.5215L48.4273 8.87184ZM44.727 44.4747H8.62699L9.57646 41.6264V13.0185L8.62699 10.1702H44.7269L43.7775 13.0185V41.6264L44.727 44.4747ZM45.3275 3.97065V7.07045H8.02656V3.97065H45.3275ZM8.02656 50.6743V47.5745H45.3275V50.6743H8.02656Z",
    fill: "#00793A"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M26.7293 27.2258C24.4017 22.7153 19.6944 19.6245 14.2784 19.6245H12.7285V21.1744C12.7285 28.8945 19.0092 35.1752 26.7293 35.1752C34.4493 35.1752 40.73 28.8945 40.73 21.1744V19.6245H39.1801C33.7642 19.6245 29.0568 22.7153 26.7293 27.2258ZM15.9575 22.8535C20.6266 23.5783 24.3255 27.2772 25.0503 31.9463C20.3812 31.2214 16.6823 27.5226 15.9575 22.8535ZM28.4083 31.9462C29.1332 27.2771 32.8321 23.5782 37.5012 22.8534C36.7762 27.5226 33.0775 31.2214 28.4083 31.9462Z",
    fill: "#00793A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52.9032,
    height: 52.9032,
    fill: "white",
    transform: "translate(0.225586 0.87085)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeedsBag);
export default __webpack_public_path__ + "static/media/seedsBag.14abb1e5.svg";
export { ForwardRef as ReactComponent };